/* ============================================================
   FRIESISCHE FEINKOST — HOMEPAGE RUNTIME
   Animations + section interactions, dependency free.
   - Content is visible without JS (JS only ADDS the hidden state).
   - Idempotent: safe to load twice, safe across Theme Editor reloads.
   - Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  if (window.FFHome) { window.FFHome.init(); return; }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var scrollItems = [];
  var rafPending = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Hero height vs. theme header ----------------
     The standalone design used an overlay header, so the hero could be a
     full 100svh. In the theme the header occupies real space above the
     hero, which pushed the buttons past the fold. Measure how far down
     the page the hero actually starts and subtract that from its height. */
  function fitHero(root) {
    $$('.ff-hero', root).forEach(function (hero) {
      var sec = hero.closest('[id^="shopify-section-"]') || hero;
      function apply() {
        var y = window.scrollY || window.pageYOffset || 0;
        var top = Math.round(sec.getBoundingClientRect().top + y);
        if (top > 0 && top < window.innerHeight * 0.5) {
          hero.style.setProperty('--ff-header-offset', top + 'px');
        } else {
          hero.style.removeProperty('--ff-header-offset');
        }
      }
      apply();
      if (hero.__ffFit) return;
      hero.__ffFit = true;
      window.addEventListener('resize', apply, { passive: true });
      window.addEventListener('load', apply);
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(apply).catch(function () { }); }
      setTimeout(apply, 300);
      setTimeout(apply, 1200);
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  var revealObserver = null;
  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ff-revealed'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    return revealObserver;
  }

  function initReveals(root) {
    if (reduced) { $$('.ff-reveal', root).forEach(function (el) { el.classList.add('ff-revealed'); }); return; }
    var roots = $$('.ff-root', root);
    if (root.classList && root.classList.contains('ff-root')) roots.push(root);
    roots.forEach(function (r) { r.classList.add('ff-js-anim'); });

    var obs = getRevealObserver();
    $$('.ff-reveal', root).forEach(function (el) {
      if (el.dataset.ffRev === '1') return;
      el.dataset.ffRev = '1';
      if (!obs) { el.classList.add('ff-revealed'); return; }
      obs.observe(el);
    });
  }

  /* ---------------- Hero entrance ---------------- */
  function initHero(root) {
    $$('.ff-hero', root).forEach(function (hero) {
      if (hero.dataset.ffInit === '1') return;
      hero.dataset.ffInit = '1';
      if (reduced) { $$('.ff-reveal', hero).forEach(function (e) { e.classList.add('ff-revealed'); }); return; }
      var delays = [0.10, 0.22, 0.38, 0.50, 0.62];
      $$('.ff-reveal', hero).forEach(function (el, i) {
        el.style.transitionDelay = (delays[i] !== undefined ? delays[i] : 0.62) + 's';
      });
      var line = $('.ff-hero-line', hero);
      if (line) {
        line.style.transform = 'scaleX(0)';
        requestAnimationFrame(function () {
          line.style.transition = 'transform .8s cubic-bezier(.22,.61,.36,1)';
          line.style.transform = 'scaleX(1)';
        });
      }
      var img = $('[data-ff-hero-img]', hero);
      if (img) {
        img.style.transform = 'scale(1.14)';
        requestAnimationFrame(function () {
          img.style.transition = 'transform 1.8s cubic-bezier(.16,.84,.44,1)';
          img.style.transform = 'scale(1.08)';
          setTimeout(function () { img.style.transition = ''; }, 1900);
        });
      }
      setTimeout(function () {
        $$('.ff-reveal', hero).forEach(function (e) { e.classList.add('ff-revealed'); });
      }, 60);
    });
  }

  /* ---------------- Category stagger ---------------- */
  function initStagger(root) {
    if (reduced) return;
    $$('[data-ff-stagger]', root).forEach(function (grid) {
      if (grid.dataset.ffInit === '1') return;
      grid.dataset.ffInit = '1';
      $$('.ff-reveal', grid).forEach(function (el, i) {
        el.style.transitionDelay = (i * 0.07) + 's';
      });
    });
  }

  /* ---------------- Scroll driven effects ---------------- */
  function registerScrollFx(root) {
    $$('[data-ff-fx]', root).forEach(function (el) {
      if (el.dataset.ffFxInit === '1') return;
      el.dataset.ffFxInit = '1';
      if (reduced) return;
      scrollItems.push({ el: el, type: el.dataset.ffFx, amt: parseFloat(el.dataset.ffFxAmount || '0') });
    });
    onScroll();
  }

  function onScroll() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      var vh = window.innerHeight || 1;
      for (var i = scrollItems.length - 1; i >= 0; i--) {
        var it = scrollItems[i];
        if (!it.el.isConnected) { scrollItems.splice(i, 1); continue; }
        var r = it.el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var p = (vh - r.top) / (vh + r.height);
        p = Math.max(0, Math.min(1, p));
        if (it.type === 'parallax') {
          it.el.style.transform = 'translate3d(0,' + ((p - 0.5) * it.amt).toFixed(2) + '%,0)';
        } else if (it.type === 'zoom') {
          var s = 1 + (1 - p) * it.amt;
          it.el.style.transform = 'scale(' + s.toFixed(4) + ')';
        } else if (it.type === 'heroParallax') {
          it.el.style.transform = 'scale(1.08) translate3d(0,' + (p * it.amt).toFixed(2) + '%,0)';
        }
      }
    });
  }

  /* ---------------- Stat counters ---------------- */
  function initCounters(root) {
    $$('[data-ff-count]', root).forEach(function (el) {
      if (el.dataset.ffInit === '1') return;
      el.dataset.ffInit = '1';
      var target = parseFloat(el.dataset.ffCount) || 0;
      var suffix = el.dataset.ffSuffix || '';
      var prefix = el.dataset.ffPrefix || '';
      if (reduced || !('IntersectionObserver' in window)) { el.textContent = prefix + target + suffix; return; }
      var io = new IntersectionObserver(function (entries, o) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          o.disconnect();
          var start = null, dur = 1800;
          function step(ts) {
            if (start === null) start = ts;
            var t = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - t, 3);
            el.textContent = prefix + Math.round(target * eased) + suffix;
            if (t < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.2 });
      io.observe(el);
    });
  }

  /* ---------------- Magnetic buttons ---------------- */
  function initMagnetic(root) {
    if (!fine || reduced) return;
    $$('.ff-magnetic', root).forEach(function (el) {
      if (el.dataset.ffMag === '1') return;
      el.dataset.ffMag = '1';
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.25;
        var y = (e.clientY - r.top - r.height / 2) * 0.30;
        el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------------- Testimonial carousel ---------------- */
  function initCarousels(root) {
    $$('[data-ff-carousel]', root).forEach(function (wrap) {
      if (wrap.dataset.ffInit === '1') return;
      wrap.dataset.ffInit = '1';
      var track = $('[data-ff-carousel-track]', wrap);
      var dotsWrap = $('[data-ff-carousel-dots]', wrap);
      if (!track || !dotsWrap) return;
      var slides = track.children.length;
      if (slides < 2) { dotsWrap.style.display = 'none'; return; }
      var current = 0, timer = null;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < slides; i++) {
        (function (i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Bewertung ' + (i + 1) + ' anzeigen');
          if (i === 0) dot.classList.add('ff-active');
          dot.addEventListener('click', function () { goTo(i); restart(); });
          dotsWrap.appendChild(dot);
        })(i);
      }
      function goTo(i) {
        current = i;
        track.style.transition = reduced ? 'none' : 'transform .6s cubic-bezier(.22,.61,.36,1)';
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        Array.prototype.forEach.call(dotsWrap.children, function (d, j) { d.classList.toggle('ff-active', j === i); });
      }
      function restart() {
        if (timer) clearInterval(timer);
        if (wrap.dataset.ffAutoplay === 'false') return;
        timer = setInterval(function () { goTo((current + 1) % slides); }, parseInt(wrap.dataset.ffInterval || '5500', 10));
      }
      restart();
      wrap.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      wrap.addEventListener('mouseleave', restart);
    });
  }

  /* ---------------- Toast ---------------- */
  function toast(msg, linkHtml) {
    var t = $('#ff-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ff-toast';
      t.className = 'ff-toast ff-root';
      t.setAttribute('role', 'status');
      t.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg><span id="ff-toast-msg"></span>';
      document.body.appendChild(t);
    }
    $('#ff-toast-msg', t).innerHTML = (msg || '') + (linkHtml || '');
    t.classList.add('ff-show');
    clearTimeout(window.__ffToastTimer);
    window.__ffToastTimer = setTimeout(function () { t.classList.remove('ff-show'); }, 3600);
  }

  /* ---------------- Cart ---------------- */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function notifyCart() {
    ['cart:refresh', 'cart:update', 'cart-update', 'cartUpdated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'ff-home' } }));
    });
    fetch(cartRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.cart-count-bubble span:first-child, [data-cart-count], .cart-count')
          .forEach(function (el) { if (/^\s*\d+\s*$/.test(el.textContent)) el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('ff:cart:updated', { bubbles: true, detail: cart }));
      })
      .catch(function () { });
  }

  function addToCart(variantId, qty, name, btn) {
    if (!variantId) return;
    var root = cartRoot();
    if (btn) { btn.disabled = true; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) {
          toast((res.data && res.data.description) || 'Artikel konnte nicht hinzugefügt werden.');
          return;
        }
        if (btn) { btn.classList.add('ff-added'); setTimeout(function () { btn.classList.remove('ff-added'); }, 900); }
        toast((name || 'Artikel') + ' hinzugefügt. ', '<a href="' + root + 'cart">Warenkorb ansehen</a>');
        notifyCart();
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        window.location.href = root + 'cart/' + variantId + ':' + (qty || 1);
      });
  }

  /* ---------------- Product card helpers ---------------- */
  function cardData(card) {
    if (card.__ffData) return card.__ffData;
    var s = $('[data-ff-product-json]', card);
    if (!s) return null;
    try { card.__ffData = JSON.parse(s.textContent); } catch (e) { card.__ffData = null; }
    return card.__ffData;
  }

  function applyVariant(card, idx) {
    var d = cardData(card);
    if (!d || !d.variants[idx]) return;
    var v = d.variants[idx];
    card.dataset.ffVariant = idx;
    var price = $('[data-ff-price]', card);
    var was = $('[data-ff-price-was]', card);
    var unit = $('[data-ff-unit]', card);
    var img = $('[data-ff-img]', card);
    var btn = $('[data-ff-add]', card);
    if (price) price.textContent = v.price;
    if (was) { was.textContent = v.compare || ''; was.style.display = v.compare ? '' : 'none'; }
    if (unit) { unit.textContent = v.unit || ''; }
    if (img && v.img && img.getAttribute('src') !== v.img) {
      img.style.opacity = '0';
      setTimeout(function () { img.removeAttribute('srcset'); img.src = v.img; img.style.opacity = '1'; }, 160);
    }
    if (btn) {
      btn.dataset.ffVariantId = v.id;
      btn.disabled = !v.available;
      var lbl = $('[data-ff-add-label]', btn);
      if (lbl) lbl.textContent = v.available ? (btn.dataset.ffLabel || 'In den Warenkorb') : (btn.dataset.ffSoldOut || 'Ausverkauft');
    }
    $$('[data-ff-size]', card).forEach(function (c) { c.classList.toggle('ff-active', parseInt(c.dataset.ffSize, 10) === idx); });
  }

  /* ---------------- Quick view ---------------- */
  function openQuickView(card) {
    var d = cardData(card);
    var section = card.closest('[data-ff-section]');
    var qv = section ? $('[data-ff-qv]', section) : null;
    if (!d || !qv) return;
    var idx = parseInt(card.dataset.ffVariant || '0', 10);
    qv.__ffCard = card;
    qv.__ffData = d;
    $('[data-ff-qv-img]', qv).src = d.variants[idx].img || d.image || '';
    $('[data-ff-qv-img]', qv).alt = d.title;
    $('[data-ff-qv-cat]', qv).textContent = d.type || d.vendor || '';
    $('[data-ff-qv-title]', qv).textContent = d.title;
    $('[data-ff-qv-desc]', qv).textContent = d.desc || '';
    $('[data-ff-qv-price]', qv).textContent = d.variants[idx].price;
    var qvWas = $('[data-ff-qv-was]', qv);
    qvWas.textContent = d.variants[idx].compare || '';
    qvWas.style.display = d.variants[idx].compare ? '' : 'none';
    $('[data-ff-qv-unit]', qv).textContent = d.variants[idx].unit || '';
    $('[data-ff-qv-qty]', qv).textContent = '1';
    var sizes = $('[data-ff-qv-sizes]', qv);
    sizes.innerHTML = '';
    if (d.variants.length > 1) {
      d.variants.forEach(function (v, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ff-size-chip' + (i === idx ? ' ff-active' : '');
        b.textContent = v.title;
        b.dataset.ffQvSize = i;
        if (!v.available) b.disabled = true;
        sizes.appendChild(b);
      });
    }
    qv.dataset.ffIdx = idx;
    var addBtn = $('[data-ff-qv-add]', qv);
    addBtn.dataset.ffVariantId = d.variants[idx].id;
    addBtn.disabled = !d.variants[idx].available;
    $('[data-ff-qv-link]', qv).href = d.url;
    qv.classList.add('ff-open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuickView(qv) {
    if (!qv) qv = $('.ff-qv-overlay.ff-open');
    if (!qv) return;
    qv.classList.remove('ff-open');
    document.body.style.overflow = '';
  }

  /* ---------------- Delegated events (survive re-render) ---------------- */
  function bindGlobal() {
    if (document.documentElement.dataset.ffBound === '1') return;
    document.documentElement.dataset.ffBound = '1';

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      /* FAQ */
      var faqBtn = t.closest('.ff-faq-question');
      if (faqBtn) {
        var item = faqBtn.closest('.ff-faq-item');
        var answer = $('.ff-faq-answer', item);
        var isOpen = item.classList.contains('ff-open');
        var list = item.closest('.ff-faq-list');
        if (list && list.dataset.ffSingle !== 'false') {
          $$('.ff-faq-item.ff-open', list).forEach(function (o) {
            if (o === item) return;
            o.classList.remove('ff-open');
            $('.ff-faq-question', o).setAttribute('aria-expanded', 'false');
            $('.ff-faq-answer', o).style.maxHeight = null;
          });
        }
        if (isOpen) {
          item.classList.remove('ff-open');
          faqBtn.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = null;
        } else {
          item.classList.add('ff-open');
          faqBtn.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
        return;
      }

      /* Product filter tabs */
      var pill = t.closest('[data-ff-filter]');
      if (pill) {
        var sec = pill.closest('[data-ff-section]');
        $$('[data-ff-filter]', sec).forEach(function (p) {
          p.classList.toggle('ff-active', p === pill);
          p.setAttribute('aria-selected', p === pill ? 'true' : 'false');
        });
        $$('[data-ff-panel]', sec).forEach(function (panel) {
          panel.hidden = panel.dataset.ffPanel !== pill.dataset.ffFilter;
        });
        $$('[data-ff-panel]:not([hidden]) .ff-reveal', sec).forEach(function (el) { el.classList.add('ff-revealed'); });
        return;
      }

      /* Variant chips on card */
      var chip = t.closest('[data-ff-size]');
      if (chip && !chip.disabled) {
        var c = chip.closest('.ff-product-card');
        if (c) { applyVariant(c, parseInt(chip.dataset.ffSize, 10)); return; }
      }

      /* Qty steppers */
      var step = t.closest('[data-ff-qty-step]');
      if (step) {
        var box = step.closest('[data-ff-qty-box]');
        var out = $('[data-ff-qty]', box);
        var cur = parseInt(out.textContent, 10) || 1;
        out.textContent = Math.min(20, Math.max(1, cur + parseInt(step.dataset.ffQtyStep, 10)));
        return;
      }

      /* Add to cart (card) */
      var add = t.closest('[data-ff-add]');
      if (add) {
        e.preventDefault();
        var card2 = add.closest('.ff-product-card');
        var qtyEl = card2 ? $('[data-ff-qty]', card2) : null;
        var d2 = card2 ? cardData(card2) : null;
        addToCart(add.dataset.ffVariantId, qtyEl ? qtyEl.textContent : 1, d2 ? d2.title : '', add);
        return;
      }

      /* Simple add-to-cart (spotlight) */
      var addS = t.closest('[data-ff-add-simple]');
      if (addS) {
        e.preventDefault();
        addToCart(addS.dataset.ffVariantId, 1, addS.dataset.ffName, addS);
        return;
      }

      /* Quick view open */
      var qvBtn = t.closest('[data-ff-quickview]');
      if (qvBtn) { e.preventDefault(); openQuickView(qvBtn.closest('.ff-product-card')); return; }

      /* Quick view size */
      var qvSize = t.closest('[data-ff-qv-size]');
      if (qvSize && !qvSize.disabled) {
        var qv2 = qvSize.closest('[data-ff-qv]');
        var i2 = parseInt(qvSize.dataset.ffQvSize, 10);
        var dd = qv2.__ffData;
        qv2.dataset.ffIdx = i2;
        $$('[data-ff-qv-size]', qv2).forEach(function (b) { b.classList.toggle('ff-active', b === qvSize); });
        $('[data-ff-qv-price]', qv2).textContent = dd.variants[i2].price;
        var w = $('[data-ff-qv-was]', qv2);
        w.textContent = dd.variants[i2].compare || '';
        w.style.display = dd.variants[i2].compare ? '' : 'none';
        $('[data-ff-qv-unit]', qv2).textContent = dd.variants[i2].unit || '';
        var qim = $('[data-ff-qv-img]', qv2);
        if (dd.variants[i2].img) { qim.style.opacity = '0'; setTimeout(function () { qim.src = dd.variants[i2].img; qim.style.opacity = '1'; }, 160); }
        var ab = $('[data-ff-qv-add]', qv2);
        ab.dataset.ffVariantId = dd.variants[i2].id;
        ab.disabled = !dd.variants[i2].available;
        if (qv2.__ffCard) applyVariant(qv2.__ffCard, i2);
        return;
      }

      /* Quick view add */
      var qvAdd = t.closest('[data-ff-qv-add]');
      if (qvAdd) {
        e.preventDefault();
        var qv3 = qvAdd.closest('[data-ff-qv]');
        var q3 = $('[data-ff-qv-qty]', qv3);
        addToCart(qvAdd.dataset.ffVariantId, q3 ? q3.textContent : 1, qv3.__ffData ? qv3.__ffData.title : '', qvAdd);
        return;
      }

      /* Quick view close */
      if (t.closest('[data-ff-qv-close]') || (t.classList && t.classList.contains('ff-qv-overlay'))) {
        closeQuickView(t.closest('[data-ff-qv]'));
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickView();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---------------- Init ---------------- */
  function init(scope) {
    var root = scope || document;
    bindGlobal();
    fitHero(root);
    initHero(root);
    initStagger(root);
    initReveals(root);
    registerScrollFx(root);
    initCounters(root);
    initMagnetic(root);
    initCarousels(root);
  }

  window.FFHome = { init: init, toast: toast, addToCart: addToCart };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Safety net: never leave content hidden */
  setTimeout(function () {
    $$('.ff-reveal:not(.ff-revealed)').forEach(function (el) { el.classList.add('ff-revealed'); });
  }, 4500);

  /* Theme Editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    scrollItems = scrollItems.filter(function (i) { return i.el.isConnected; });
  });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
